import React from "react";
import { GrLocation } from "react-icons/gr";
import { useSelector } from "react-redux";
import { List } from "antd";

import styles from "./GuestScreen4.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import moment from "moment";

const GuestScreen4 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Agenda"} textClass={styles.heading} />
      <List
        dataSource={WeddingWeb?.agendas?.length > 0 ? WeddingWeb?.agendas : []}
        className={styles.list}
        renderItem={(item, index) => {
          
          
          return (
            <div className={styles.listItem} key={index}>
              <TextComponent text={item?.title} textClass={styles.title} />
              <TextComponent
                text={item?.location_title}
                textClass={styles.location_name}
              />

              <div className={styles.dateTimeDiv}>
                <div className={styles.dateTime}>
                  <TextComponent text={moment(item?.date).format("MMM DD, yyyy")} />
                </div>
                <div className={styles.dateTime}>
                  <TextComponent text={moment(item?.time, "HH:mm").format("hh:mm A")} />
                </div>
              </div>
              <div className={styles.addressDiv}>
                <GrLocation className={styles.icon} />
                <TextComponent
                  text={item?.location}
                  textClass={styles.address}
                />
              </div>
            </div>
          );
        }}
      />
      <div className={styles.submitBtn}>
        <SubmitButton
          btnClass={styles.nextBtn2}
          title={"Next"}
          onClick={() => setCurrentStep((prev) => prev + 1)}
        />
      </div>
    </div>
  );
};

export default GuestScreen4;
